import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 bg-slate-950" data-id="element-49">
      <div className="container mx-auto px-4" data-id="element-50">
        <div className="max-w-3xl mx-auto bg-gradient-to-br from-slate-900 to-slate-800 border border-slate-700 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-2xl" data-id="element-51">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-green-400 to-transparent" data-id="element-52"></div>

          <div className="w-20 h-20 bg-green-500/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-53">
            <ShieldCheck className="w-10 h-10 text-green-400" data-id="element-54" />
          </div>

          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-55">
            Garantía de Satisfacción de 7 Días
          </h2>

          <p className="text-slate-300 text-lg leading-relaxed mb-0" data-id="element-56">
            Cero riesgo para vos. Si aplicás el método y sentís que no te aporta
            valor, o simplemente decidís que no es para vos, te devolvemos el
            100% de tu dinero. Sin preguntas, sin vueltas.
          </p>
        </div>
      </div>
    </section>;
}